import { atom, useAtom } from 'jotai';

export type TYPE_MODAL_VIEW =
  | 'LOGOUT_VIEW'
  | 'TERM_VIEW'
  | 'REGISTER_VIEW'
  | 'RETIRE_VIEW'
  | 'PLANT_VIEW'
  | 'SEND_VIEW'
  | 'REVOKE_VIEW'
  | 'DELEGATE_VIEW'
  | 'ACCESS_VIEW'
  | 'INCREASE_STORAGE'
  | 'WITHDRAW_STORAGE';

const modalAtom = atom({
  isOpen: false,
  text: '',
  optional: '',
  view: 'LOGOUT_VIEW',
  selected: [],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  callback: (c) => {}
});

export function useModal() {
  const [state, setState] = useAtom(modalAtom);
  const openModal = (
    view: TYPE_MODAL_VIEW,
    text = '',
    selected?: string[],
    callback?: (s) => void,
    optional?: string
  ) =>
    setState({
      ...state,
      isOpen: true,
      text,
      view,
      callback,
      selected,
      optional
    });
  const closeModal = () =>
    setState({ ...state, isOpen: false, selected: [], text: '', optional: '' });

  return {
    ...state,
    openModal,
    closeModal
  };
}
